// エントリーポイント：Greenwood
import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { WorldScene } from './scenes/WorldScene';
import { UIScene } from './scenes/UIScene';
import { GameOverScene } from './scenes/GameOverScene';
import { VictoryScene } from './scenes/VictoryScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  width: 768,
  height: 480,
  pixelArt: true,
  backgroundColor: '#0a140a',
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [BootScene, WorldScene, UIScene, GameOverScene, VictoryScene],
};

const game = new Phaser.Game(config);
// デバッグ：開発時にゲームインスタンスへ window 経由でアクセス可能にする
(window as unknown as { game: Phaser.Game }).game = game;
console.log('[Greenwood] game created', game);
